module.exports = __webpack_public_path__ + "static/media/usa_ecopay.bd3bb63e.png";